import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';

const COOKIE_CONSENT_KEY = 'kodo_cookie_consent';

export const getCookieConsent = () => {
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  return consent === 'accepted';
};

export const setCookieConsent = (accepted) => {
  localStorage.setItem(COOKIE_CONSENT_KEY, accepted ? 'accepted' : 'declined');
};

export const hasRespondedToConsent = () => {
  return localStorage.getItem(COOKIE_CONSENT_KEY) !== null;
};

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Show banner if user hasn't responded yet
    if (!hasRespondedToConsent()) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent(true);
    setShowBanner(false);
    // Reload to initialize GA
    window.location.reload();
  };

  const handleDecline = () => {
    setCookieConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-lg z-50 p-4 md:p-6">
      <div className="container mx-auto max-w-4xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-1">
            <p className="text-slate-700 text-sm md:text-base">
              We use cookies to analyse how you use our site and improve your experience. 
              By clicking "Accept", you consent to our use of cookies.{' '}
              <a href="/terms" className="text-primary hover:underline">
                Learn more
              </a>
            </p>
          </div>
          <div className="flex gap-3 w-full md:w-auto">
            <Button
              onClick={handleDecline}
              variant="outline"
              className="flex-1 md:flex-none rounded-full px-6"
              data-testid="cookie-decline-button"
            >
              Decline
            </Button>
            <Button
              onClick={handleAccept}
              className="flex-1 md:flex-none rounded-full px-6 bg-primary text-white"
              data-testid="cookie-accept-button"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
